import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.empty-state.title',
		defaultMessage: 'No pull requests yet',
		description: 'The title of the pull requests empty state.',
	},
	description: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.empty-state.description',
		defaultMessage:
			'View and filter the latest pull requests linked to issues in this project. To get started, add issue keys to pull request titles in your connected development tool. ',
		description: 'The description of the pull request empty state.',
	},
	link: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.empty-state.link',
		defaultMessage: 'Learn more',
		description:
			'The text for the link to an informational page explaining more about the feature.',
	},
});
